<template>
  <mtd-container>
    <mtd-header height="48px">
      <div style="display:flex; align-items: center; height: 80%">
        <div class="title" style="margin-left: 31px; display: flex; align-items: center">{{ $getText('wenshu_menu_title', '文枢文件管控平台') }}
          <a href="https://cryptbox.sankuai.com/" target="_blank">
            <mtd-button style="color: #FFFFFF; border: 2px solid #FFFFFF; background: transparent; font-weight: bold; margin-left: 31px">
              {{ $getText('wenshu_menu_download_button', '文枢客户端下载') }}</mtd-button>
          </a>
        </div>
        <div class="user-name" style="margin-right: 10px;margin-left: auto;">
          <mtd-dropdown trigger="hover">
            <mtd-button type="text" style="padding:0;width:22px; min-width: 22px;">
              <img class="user-name-img" :src="login_user.image"/>
            </mtd-button>
            <mtd-dropdown-menu slot="dropdown" class="platform-user-dropdown">
              <mtd-dropdown-menu-item>
                <div class="platform-user-info">
                  <img class="platform-user-img" :src="login_user.image"/>
                  <span class="platform-user-name">{{ login_user.name }}</span>
                  <span class="platform-user-name">{{ login_user.mis }}</span>
                </div>
              </mtd-dropdown-menu-item>
              <mtd-dropdown-menu-item>
                <div style="padding: 4px 12px; color: rgba(0, 0, 0, 0.84);">
                  <mtd-button type="text" icon="mtdicon mtdicon-log-out" @click="logout">{{ $getText('wenshu_menu_logout', '退出') }}</mtd-button>
                </div>
              </mtd-dropdown-menu-item>
            </mtd-dropdown-menu>
          </mtd-dropdown>
        </div>
      </div>
    </mtd-header>
    <mtd-container>
      <mtd-aside :class="isCollapse ? 'isCollapse' : ''" style="z-index: 1;">
        <mtd-menu v-model="activeName" class="demo-menu-collapse" mode="inline" :collapse="isCollapse"
                  @select="menu_click" :base-indent="14" :accordion="true" :default-expanded-names="expanded_names">
          <!-- 第一级目录 -->
          <div v-for="(item, index) in menu_list" :key="'level1_'+index">
            <mtd-submenu v-if="item.children && item.children.length > 0" :name="item.path">
              <i slot="icon" class="mtdicon icon font" v-bind:class="item.icon"></i>
              <template slot="title" :title="item.i18n ? $getText(item.i18n, item.name) : item.name">{{ item.i18n ? $getText(item.i18n, item.name) : item.name }}</template>
              <!-- 第二级目录 -->
              <div v-for="(child, secondIndex) in item.children" :key="'level2_'+secondIndex">
                <mtd-submenu v-if="child.children && child.children.length > 0" :name="child.path">
                  <template slot="title">{{ child.i18n ? $getText(child.i18n, child.name) : child.name }}</template>
                  <!-- 第三级目录 -->
                  <mtd-menu-item v-for="(thirdChild, thirdIndex) in child.children" :key="'level3_'+thirdIndex"
                                 :name="thirdChild.path">
                    {{ thirdChild.i18n ? $getText(thirdChild.i18n, thirdChild.name) : thirdChild.name }}
                  </mtd-menu-item>
                </mtd-submenu>
                <mtd-menu-item v-else :name="child.path">
                  {{ child.i18n ? $getText(child.i18n, child.name) : child.name }}
                </mtd-menu-item>
              </div>
            </mtd-submenu>
            <mtd-menu-item v-else :name="item.path" :title="item.i18n ? $getText(item.i18n, item.name) : item.name">
              {{ item.i18n ? $getText(item.i18n, item.name) : item.name }}
              <i slot="icon" class="mtdicon icon font" v-bind:class="item.icon"></i>
            </mtd-menu-item>
          </div>
        </mtd-menu>
        <div class="collapse-btn-container">
          <mtd-icon-button type="secondary" icon="mtdicon mtdicon-collapse" class="collapse-icon"
                           @click="menus_collapse"/>
        </div>
      </mtd-aside>
      <mtd-main>
        <router-view @reload_active_tab="reload_active_tab"></router-view>
      </mtd-main>
    </mtd-container>
  </mtd-container>
</template>

<script>

  import {mapActions} from 'vuex';

  export default {
    name: 'MainLayout',
    data() {
      return {
        isCollapse: false,
        activeName: 'file/outer',
        expanded_names: []
      };
    },
    computed: {
      login_user() {
        return this.$store.getters.get_login_user;
      },
      menu_list() {
        return this.$store.getters.get_menu_list;
      }
    },
    mounted() {
      this.reload_active_tab();
    },
    methods: {
      ...mapActions(['logout']),
      menu_click(menuItem) {
        this.$router.push(`/${menuItem.name}`).catch(() => {
        });
      },
      menus_collapse: function () {
        this.isCollapse = !this.isCollapse;
      },
      reload_active_tab() {
        let fullPath = this.$route.path;
        if (!fullPath || fullPath === '/') {
          return;
        }
        fullPath = fullPath.substr(1);
        this.activeName = fullPath;
        // 菜单展开
        let path_array = fullPath.split("/");
        let expanded_names = [];
        let prefix = ""
        let split_str = ""
        for (let i = 0; i < path_array.length; i++) {
          let name = prefix + split_str + path_array[i];
          expanded_names.push(name);
          prefix = name;
          split_str = "/";
        }
        this.expanded_names = expanded_names;
      },
    },
  };
</script>

<style scoped>
  @import '../styles/main-container.css';
  @import '../styles/public.css';
  @import '../styles/iconfont/iconfont.css';

  .platform-user-dropdown .mtd-dropdown-menu-item {
    padding: 0;
  }

  .platform-user-dropdown .platform-user-info {
    padding: 8px 12px;
    border-bottom: 1px solid #f7f7f7;
    position: relative;
  }

  .platform-user-dropdown .platform-user-info .platform-user-img {
    height: 28px;
    width: 28px;
    border-radius: 50%;
    vertical-align: middle;
    position: absolute;
    top: 17px;
  }

  .platform-user-dropdown .platform-user-info .platform-user-name {
    margin-left: 36px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.87);
    display: block;
    line-height: 22px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item {
    height: 36px;
    line-height: 36px;
    padding: 0 12px;
    cursor: pointer;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item .platform-user-dropdown-link {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: rgba(0, 0, 0, 0.87);
    font-size: 14px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) {
    height: 48px;
    line-height: 48px;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:nth-last-child(1) i {
    margin-right: 4px;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
    vertical-align: middle;
  }

  .platform-user-dropdown .platform-user-dropdown-list .platform-user-dropdown-item:hover {
    background-color: #f7f7f7;
  }

  .mtd-aside .mtd-menu .mtd-menu-item-icon, .mtd-aside .mtd-menu .mtd-submenu .mtd-submenu-icon {
    height: 40px !important;
  }
</style>
